const state = {
  isOld: false,
}

const mutations = {
  SET_IS_OLD: (state, isOld) => {
    state.isOld = isOld
  },
}

const actions = {
  //设置长辈版全局参数
  setIsOld: ({ commit }, isOld) => {
    commit('SET_IS_OLD', isOld)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
